import { useState, useEffect } from "react";
import { API } from "../api";
import { theme } from "../theme";
import RankioLogo from "../components/RankioLogo";

// ── Expired Screen ─────────────────────────────────────────────────────────────
export default function ExpiredScreen({ onBack }) {
  // Ceník se tahá z backendu, aby se nemohl rozejít s tím, co appka vymáhá.
  const [plans, setPlans] = useState([]);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    fetch(API + "/plans")
      .then(r => r.json())
      .then(d => { if (alive) setPlans(d.plans || []); })
      .catch(() => { if (alive) setPlans([]); });
    return () => { alive = false; };
  }, []);

  const handleUpgrade = async (planId) => {
    if (!email.trim()) { setError("Zadejte email."); return; }
    setLoading(planId); setError("");
    try {
      const res = await fetch(API + "/create-checkout-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), plan: planId }),
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
      else setError(data.detail || "Chyba při přesměrování.");
    } catch(e) { setError("Chyba připojení."); }
    setLoading("");
  };

  return (
    <div style={{ minHeight: "100vh", background: `linear-gradient(135deg, ${theme.blueSoft} 0%, #fff 55%, #eef3ff 100%)`, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: theme.font, padding: 24 }}>
      <div style={{ width: "100%", maxWidth: 520 }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <RankioLogo height={44} />
          <div style={{ marginTop: 24, fontSize: 32 }}>⏰</div>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: theme.ink, marginTop: 12, marginBottom: 8 }}>Váš trial vypršel</h1>
          <p style={{ color: theme.inkSoft, fontSize: 15, lineHeight: 1.6 }}>Vyberte plán a pokračujte ve sledování pozic</p>
        </div>

        <div style={{ background: theme.bg, borderRadius: theme.rCard, padding: 28, boxShadow: theme.shadowMd, border: `1px solid ${theme.line}`, marginBottom: 20 }}>
          <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: theme.inkSoft, textTransform: "uppercase", letterSpacing: "0.07em", marginBottom: 8 }}>Váš email</label>
          <input
            value={email}
            onChange={e => { setEmail(e.target.value); setError(""); }}
            placeholder="email@example.com"
            style={{ width: "100%", boxSizing: "border-box", border: `1.5px solid ${theme.line}`, borderRadius: 10, padding: "11px 14px", fontSize: 14, fontFamily: theme.font, color: theme.ink, background: theme.bgSoft, marginBottom: 20 }}
            onFocus={e => e.target.style.borderColor = theme.blue}
            onBlur={e => e.target.style.borderColor = theme.line}
          />

          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {plans.length === 0 && (
              <p style={{ fontSize: 13, color: theme.mut, textAlign: "center", padding: "12px 0" }}>Načítám ceník…</p>
            )}
            {plans.map(plan => (
              <div key={plan.key} style={{ border: `1.5px solid ${theme.line}`, borderRadius: 14, padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                <div>
                  <p style={{ fontWeight: 700, fontSize: 16, color: theme.ink }}>{plan.name}</p>
                  <p style={{ fontSize: 13, color: theme.inkSoft, marginTop: 2 }}>až <span style={{ fontVariantNumeric: theme.tnum }}>{plan.max_products}</span> produktů</p>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <span style={{ fontWeight: 700, fontSize: 16, color: theme.ink, fontVariantNumeric: theme.tnum }}>{new Intl.NumberFormat("cs-CZ").format(plan.price_monthly)} Kč/měs</span>
                  <button onClick={() => handleUpgrade(plan.key)} disabled={!!loading} style={{ background: `linear-gradient(135deg, ${theme.blue}, ${theme.blueDark})`, border: "none", borderRadius: theme.rBtn, padding: "10px 18px", color: "#fff", fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", opacity: loading === plan.key ? 0.7 : 1, whiteSpace: "nowrap" }}>
                    {loading === plan.key ? "…" : "Vybrat"}
                  </button>
                </div>
              </div>
            ))}
          </div>
          {error && <p style={{ color: theme.bad, fontSize: 13, marginTop: 12 }}>{error}</p>}
        </div>

        <button onClick={onBack} style={{ width: "100%", background: "none", border: "none", color: theme.mut, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>
          ← Zpět na přihlášení
        </button>
      </div>
    </div>
  );
}
